import { TFunction } from "i18next";
import { SelectOption } from "../../FormInputs/types";
import { format } from "date-fns";
import {
  isDateRange,
  FilterName,
  FilterInputData,
} from "@/components/FilterSidebar/types";
import { FilterNameWithOpts } from "../../FilterSidebar/hooks/useFilterFieldsOptions";

type FilterValue = FilterInputData[keyof FilterInputData];

const customDisplayValues = new Set<FilterName>([
  "studentType",
  "goingElsewhere",
  "attendedALiveEvent",
  "country",
  "directAdmission",
  "deposited",
  "firstGeneration",
  "studentAthlete",
  "campusVisit",
]);
export const getPillValueAsText = (
  name: FilterName,
  value: FilterValue,
  options: Record<FilterNameWithOpts, SelectOption[]>,
  t: TFunction<"translation", undefined>,
  cutoffCount: number | null = null,
) => {
  let opts: SelectOption[] = [];
  if (name in options) {
    opts = options[name as FilterNameWithOpts];
  }

  if (isDateRange(value)) {
    const to = value.to ? format(value.to, "MM-dd-yyyy") : "--";
    const from = value.from ? format(value.from, "MM-dd-yyyy") : "--";
    return (
      t(`filters.${name}`) + `: ` + t("filters.pills.dateRange", { from, to })
    );
  }

  let values = Array.isArray(value) ? value : [value];

  if (customDisplayValues.has(name)) {
    return t(`filters.pills.${name}.${value}`);
  }

  let plusCount = "";

  if (cutoffCount !== null) {
    const additionalFiltersCount = values.length - cutoffCount;
    plusCount = additionalFiltersCount > 0 ? ` +${additionalFiltersCount}` : "";
    values = values.slice(0, cutoffCount);
  }

  const valuesStr = values
    .map((val) => getLabelFromSelectOpts(val, opts) ?? val)
    .join(", ");

  return `${t(`filters.${name}`)}: ${valuesStr}${plusCount}`;
};

function getLabelFromSelectOpts(value: string | null, opts: SelectOption[]) {
  for (const opt of opts) {
    if (value === opt.value) return opt.label;
  }
  return null;
}
